import LocalStorage from "local-storage-json"
import * as Objdict from "objdict"

// https://frog-tactics.s3-us-west-2.amazonaws.com/assets/music/overworld.wav

const settings = {
    "volume": 0.5
}

import triggers from "@frog/source/juice/audiotriggers.js"

const audiomix = new class Audiomix {
    constructor() {
        this.userSoundVolume = LocalStorage.get("sound-volume")
        this.userMusicVolume = LocalStorage.get("music-volume")

        if(this.userSoundVolume == undefined) {
            this.userSoundVolume = 0.5
        }
        if(this.userMusicVolume == undefined) {
            this.userMusicVolume = 0.5
        }
        // this.musicPlaying = LocalStorage.get("musicPlaying")
        // if(this.musicPlaying == undefined) {
        //     this.musicPlaying = {"track": "debris", "time": Date.now()}
        //     LocalStorage.set("musicPlaying", this.musicPlaying)
        // }
    }
    playMusic(name, params) {
        params = params || {}
        if(this.music === music[name]) {
            // console.log("Could not find the music.")
            return
        }
        if(this.music !== undefined) {
            this.music.pause()
        }
        this.music = music[name]
        this.music.volume = this.musicVolume
        this.music.currentTime = params.currentTime || 0
        this.music.loop = params.loop || false
        this.music.play()
        // this.music.volume = this.musicVolume * this.devMusicVolume
        // if(__STAGE__ === "DEVELOPMENT") {
        //     this.music.currentTime = (Date.now() - this.musicPlaying.time) / 1000
        // }
        // this.music.addEventListener("ended", () => {
        //     LocalStorage.set("musicPlaying", {
        //         "time": Date.now(),
        //         "track": "debris"
        //     })
        //     this.music.currentTime = 0
        //     this.music.play()
        // })
    }
    stopMusic() {
        if(this.music !== undefined) {
            this.music.pause()
        }
    }
    trigger(key) {
        if(hasTriggered == false) return
        const trigger = triggers[key]
        if(trigger == undefined) {
            console.log("Could not find audio trigger:", key)
            return
        }

        if(trigger.killTrigger != undefined
        && triggers[trigger.killTrigger] != undefined) {
            if(triggers[trigger.killTrigger].audio instanceof Audio) {
                triggers[trigger.killTrigger].audio.pause()
            } else if(triggers[trigger.killTrigger].audio instanceof Array) {
                triggers[trigger.killTrigger].audio.forEach((audio) => audio.pause())
            }
        }
        if(trigger.killTrigger2 != undefined
        && triggers[trigger.killTrigger2] != undefined) {
            if(triggers[trigger.killTrigger2].audio instanceof Audio) {
                triggers[trigger.killTrigger2].audio.pause()
            } else if(triggers[trigger.killTrigger2].audio instanceof Array) {
                triggers[trigger.killTrigger2].audio.forEach((audio) => audio.pause())
            }
        }

        if(trigger.audio instanceof Audio) {
            // trigger.audio.pause()
            playSound(trigger.audio, trigger.volume)
        } else if(trigger.audio instanceof Array) {
            // trigger.audio.forEach((sound) => sound.pause())
            if(trigger.type == "synchronous") {
                trigger.audio.forEach((sound) => playSound(sound, trigger.volume))
            } else if(trigger.type == "sequence") {
                playSound(trigger.audio[0], trigger.volume)
                trigger.audio.push(trigger.audio.shift())
            } else if(trigger.type == "random") {
                playSound(trigger.audio[Math.floor(Math.random() * trigger.audio.length)], trigger.volume)
            } else if(trigger.type == "march") {
                marchAudio(trigger.audio.map((audio) => audio), trigger.volume)
            } else {
                playSound(trigger.audio[0], trigger.volume)
            }
        }
    }
    // playSound(name, volume) {
    //     // if(sounds[name] == undefined) {
    //     //     // console.log("Could not find the sound.")
    //     //     return
    //     // }
    //     // if(sounds[name] == undefined) {
    //     //     sounds[name] = new Audio(name)
    //     // }
    //     sounds[name].currentTime = 0
    //     sounds[name].volume = 1 //(volume || 0.5) // this.userSoundVolume * volume
    //     sounds[name].play()
    // }
    // stopSound(name) {
    //     sounds[name].pause()
    // }
    setMusicVolume(volume) {
        this.userMusicVolume = volume
        if(this.music !== undefined) {
            this.music.volume = this.musicVolume
        }
        LocalStorage.set("music-volume", volume)
    }
    setSoundVolume(volume) {
        this.userSoundVolume = volume
        LocalStorage.set("sound-volume", volume)
    }
    get musicVolume() {
        return this.userMusicVolume
    }
    update(delta) {
        if(this.music !== undefined) {
            this.music.volume -= (this.music.volume - this.musicVolume) / 25
            if(Math.abs(this.music.volume - this.musicVolume) < 0.001) {
                this.music.volume = this.musicVolume
            }
        }
    }
}

function playSound(sound, volume = 1) {
    sound.pause()
    sound.volume = volume * settings.volume
    sound.currentTime = 0
    sound.play()
}

function marchAudio(audios, volume = 1) {
    const audio = audios.shift()
    audio.pause()
    audio.volume = volume * settings.volume
    audio.currentTime = 0
    if(audios.length == 0) {
        audio.loop = true
    } else {
        // TODO: what happens if this gets added multiple times
        audio.addEventListener("ended", () => {
            marchAudio(audios, volume)
        })
    }
    audio.play()
}

let hasTriggered = true
// let hasTriggered = false
// document.addEventListener("click", () => {
//     if(hasTriggered == false) {
//         hasTriggered = true
//         audiomix.trigger("Music:1")
//     }
// })


export default audiomix
// window.frog = window.frog || {}
// window.frog.audiomix = audiomix
